import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { CustomAccesses } from "./accesses.ts";
import { CustomComponents } from "./components.ts";

const CustomFilters = {
  application: { keys: ["id"] },
  item: { keys: ["id"] },
} as const satisfies AnyFilterSchema;
export type CustomFilters = typeof CustomFilters;

export const CustomIconUrl =
  "https://raw.githubusercontent.com/ant-design/ant-design-icons/refs/heads/master/packages/icons-svg/svg/outlined/setting.svg";

export const CustomRegistration = Registration({
  accesses: CustomAccesses,
  category: "resource",
  components: CustomComponents,
  docs: { install: "custom-resource" },
  filters: CustomFilters,
  flag: "custom-resource-integration",
  itemKind: "resource",
  label: "Custom resource",
  logoUrl: CustomIconUrl,
  maturity: "ga",
  requestType: "requestable",
  useMapping: [
    { use: "iam_write", component: "iam-write" },
    { use: "iam_read", component: "iam-assessment" },
  ],
});

registerIntegration("custom", CustomRegistration);
